import { Divider, Typography } from '@material-ui/core'
import React from 'react'

import { addCommaToPrice } from '../../../../helpers/numbers'
import { getTranslate } from '../../../../localization'
import { Charge } from '../../../../types/cart'
import { Currency } from '../../../../types/currency'
import { useStyles } from './styles/index.styles'

type PerRoomStayChargeRowProps = {
  isTotal?: boolean
  total?: number
  chargePerRoomStay?: Charge
  curruncy: Currency
}
const PerRoomStayChargeRow: React.FC<PerRoomStayChargeRowProps> = ({
  isTotal,
  total,
  chargePerRoomStay,
  curruncy
}: PerRoomStayChargeRowProps) => {
  const classes = useStyles()

  return (
    <>
      {isTotal ? <Divider className={classes.divider} /> : ''}
      <div
        className={[
          classes.tableRowForPerRoomstay,
          isTotal ? classes.tableRowDark : ''
        ].join(' ')}
        role="row">
        <Typography variant="h6" className={classes.cell} role="cell">
          {isTotal ? '' : chargePerRoomStay?.itemName}
        </Typography>
        <Typography variant="h6" className={classes.cell} role="cell">
          {isTotal ? '' : getTranslate('Per Room')}
        </Typography>
        <Typography variant="h6" className={classes.cell} role="cell">
          {isTotal ? '' : chargePerRoomStay?.quantity}
        </Typography>
        <Typography variant="h6" className={classes.cell} role="cell">
          {isTotal
            ? ''
            : chargePerRoomStay?.rate
            ? `${addCommaToPrice(chargePerRoomStay?.rate)} ${getTranslate(
                curruncy || ''
              )}`
            : 0}
        </Typography>
        <Typography variant="h6" className={classes.cell} role="cell">
          {isTotal
            ? ''
            : chargePerRoomStay?.discount
            ? `${addCommaToPrice(chargePerRoomStay?.discount!)} ${getTranslate(
                curruncy || ''
              )}`
            : 0}
        </Typography>
        <Typography variant="h6" className={classes.cell} role="cell">
          {isTotal
            ? total
              ? `${addCommaToPrice(total)} ${getTranslate(curruncy || '')}`
              : ''
            : `${addCommaToPrice(chargePerRoomStay?.total!)} ${getTranslate(
                curruncy || ''
              )}`}
        </Typography>
        <Typography variant="h6" className={classes.cell} role="cell">
          {isTotal ? '' : '-'}
        </Typography>
      </div>
    </>
  )
}

export default PerRoomStayChargeRow
